import type { InputConfig } from "@smartsuite/automation-engine-api";
import { ValueDescription_T } from "@smartsuite/automation-engine-api";
import { INPUT_APPLICATION_ID } from "./constants";

export const applicationIdInput = (applicationId?: string): InputConfig => ({
  inputId: INPUT_APPLICATION_ID,
  valueDescription: {
    type: ValueDescription_T.STRING,
    multiple: false,
  },
  value: {
    values: [
      {
        value: {
          oneofKind: "string",
          string: applicationId ?? "",
        },
      },
    ],
  },
});
